import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 10px;
`;

const MinusIcon: VFC<IIconProps> = ({ color, size }) => (
  <Wrapper>
    <svg width={size} height={2} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 1H1" stroke={color} strokeWidth={2} strokeLinecap="round" />
    </svg>
  </Wrapper>
);

export default MinusIcon;
